// Customer Configuration
// Update these values for each customer deployment

export const API_URL = import.meta.env.VITE_API_URL || 'https://api.raporgor.com';
export const API_KEY = import.meta.env.VITE_API_KEY || 'rg_api_XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
export const CUSTOMER_NAME = import.meta.env.VITE_CUSTOMER_NAME || 'Müşteri Paneli';

// Source IDs - Update for each customer
export const SOURCES = {
  KASA_RAPORU: 12,
  // Add more sources as needed
} as const;

// Theme configuration
export const THEME = {
  primaryColor: '#1890ff',
  headerColor: '#001529',
} as const;
